import ReactDOM from 'react-dom';
// Defined in general.js
/* global isLoggedInOrRemembered readCookie returnFalse toggleTeacherProfilePhotoUploadOverlay userId qsParam createCookie isMobileView */

// Defined in JSP
/* global challenge stats shouldSaveChallengeIdCookie */

import '../../external/jquery/jquery.sticky.js';
import 'react-addons-pure-render-mixin/react-addons-pure-render-mixin.js';
import { onMobileChangeExecute } from '../common/onMobileChangeExecute.js';
import { validateChallengeForm, showLongMessage, editToggle } from './challengeEdit.js';
import { editVanityURL } from '../vanityurl/vanityURL.js';
import { populateDonateOptions, addDonateOptionsClose, toggleDonateOptions } from '../donateBar/floatingDonateBar.js';
import GivingPageTabsController from './GivingPageTabsController.js';
import '../sharebar/shareBarOnClickHandlers.js';
import { validateQuickDonation } from '../giveWidget/giveWidgetFunctions.js';

if ($('.donorschoose-hideTabs').length === 0) {
    ReactDOM.render(
        <GivingPageTabsController challenge={challenge} stats={stats} />,
        document.getElementById('tabs'),
    );
}

function getDonateOptions() {
    populateDonateOptions('quickDonate', 'donationAmount');

    if ($('#donateOptions .close').length === 0) addDonateOptionsClose();

    toggleDonateOptions();
}

function uploadProfilePhoto() {
    if (readCookie('userType') === 'teacher') {
        toggleTeacherProfilePhotoUploadOverlay();
        return returnFalse();
    }
    // If not a teacher, fall through to the donor photo href
}

function showAdminLinks() {
    if ($(window).width() < 641) {
        $('.js-admin').css('display', 'block');
    } else {
        $('.js-admin').css('display', 'inline-block');
    }
}

(function () {
    function updateAdminLinks() {
        // eslint-disable-next-line eqeqeq
        if (userId != null && userId == challenge.donorId && qsParam.pageStyle != 'public') {
            showAdminLinks();
        } else {
            $('.js-admin').hide();
        }
    }

    $(window).on('signinTriggered signoutTriggered', updateAdminLinks);

    function readMorePartnerComment() {
        if ($('.js-partner-custom-message').length > 0 && $('.js-partner-custom-message').height() > 150) {
            $('.js-partner-custom-message').addClass('read-more fadeout');
            $('.js-partner-custom-message').after('<a href="#" class="read-more-link js-read-more">read more <svg class="icon icon-navigatedown"><use xlink:href="/images/icon/icon-junior.svg#icon-navigatedown"></use></svg></a>');
            $('.js-partner-custom-message').next('.js-read-more').on('click.readMore', function (event) {
                event.preventDefault();
                $('.js-partner-custom-message').removeClass('read-more fadeout');
                $(this).remove();
            });
        }
    }

    $(document).ready(function () {
        readMorePartnerComment();
        updateAdminLinks();

        $(window).on('resize', function () {
            updateAdminLinks();
        });
    });

    // eslint-disable-next-line eqeqeq
    if (challenge.type == 'Challenge') {
        createCookie('searchTermsURL', challenge.URL, 1);
        createCookie('searchTermsDesc', window.b64EncodeUnicode(challenge.name), 1);
    }
    if (shouldSaveChallengeIdCookie) {
        createCookie('challengeId', challenge.id, 2);
    }

    $('.js-edit-profile-photo').on('click', uploadProfilePhoto);
    $('.js-edit-challenge-name').on('click', function (e) {
        editToggle('challengeName', true);
        e.preventDefault();
    });
    $('.js-edit-challenge-name-form').on('submit', function () {
        return validateChallengeForm(this);
    });
    $('.js-cancel-challenge-name-edit').on('click', function (e) {
        editToggle('challengeName', false);
        e.preventDefault();
    });
    $('.js-quick-donate').on('submit', function () {
        return validateQuickDonation(this);
    });
    $('.js-see-public-page').on('click', function (e) {
        e.target.href += '&timestamp=' + (new Date()).getTime();
    });
    $('.js-edit-vanity-url').on('click', function (e) {
        editVanityURL(() => !isLoggedInOrRemembered());
        e.preventDefault();
    });
    $('.js-show-full-description').on('click', function (e) {
        showLongMessage(true);
        e.preventDefault();
    });
    $('.js-hide-full-description').on('click', function (e) {
        showLongMessage(false);
        e.preventDefault();
    });
    $('.js-edit-description').on('click', function (e) {
        editToggle('sponsorMessage', true);
        e.preventDefault();
    });
    $('.js-edit-description-form').on('submit', function () {
        return validateChallengeForm(this);
    });
    $('.js-cancel-edit-description').on('click', function (e) {
        editToggle('sponsorMessage', false);
        e.preventDefault();
    });
    $('.js-donate-button').on('click', getDonateOptions);
    $('.js-delete-challenge-form').on('submit', function () {
        return confirm('Are you sure you want to delete this Giving Page?  Your action cannot be undone.');
    });

    function mobilize(isMobile) {
        isMobile ? $('.give-bar.desktop').unstick() : $('.give-bar.desktop').sticky();
    }

    onMobileChangeExecute(mobilize);
    mobilize(isMobileView());
})();
